/**
 * Checks if a value is not null or undefined.
 *
 * @export
 * @param {*} value The value to check.
 * @returns {Boolean} True if the value is set, otherwise false.
 */
export function isSet(value) {
	return value !== null && value !== undefined
}

/**
 * Shuffles an array in O(n) time. Based on the Fisher-Yates algorithm.
 *
 * @see https://bost.ocks.org/mike/shuffle/
 * @param {*[]} array The array to shuffle.
 * @returns {*[]} The shuffled array.
 */
export function shuffle([...a]) {
	let i = a.length
	while (i) {
		const j = ~~(Math.random() * i--)
		const tmp = a[i]
		a[i] = a[j]
		a[j] = tmp
	}
	return a
}

/**
 * Returns a random integer between min & max (inclusive).
 *
 * @export
 * @param {Number} min Minimum bound.
 * @param {Number} max Maximum bound.
 * @returns {Number} The random integer.
 */
export function randInt(min, max) {
	return min + Math.random() * (max - min + 1)
}

/**
 * Chooses a random element from an array.
 *
 * @export
 * @param {*} array The array to choose from
 * @returns {*} The chosen element.
 */
export function choose(array) {
	const index = Math.floor(Math.random() * array.length)
	return array[index]
}

/**
 * Creates a new object with specified keys removed.
 *
 * @param {object} object The object to remove keys from.
 * @param {string[]} keys The keys to remove.
 * @returns {object} New object with specified keys removed.
 */
export function unpick(object, keys) {
	return Object.entries(object).reduce((acc, [key, value]) => {
		if (!keys.includes(key)) acc[key] = value
		return acc
	}, {})
}
